<template>
  <div class="container" ref="container">
    <div 
      v-for ="(event, index) in events"
      :key="event.title"
    >
    <div v-if ="index<=eventIndex" class="tetris-container" :style="tetOffsetStyle(index)" ref="tetContain">
      <TetrisPieceContainer
        :square-size="blockHeight"
        :all-grid-bounding-rects="allGridBoundingRects"
        :event-index="index"
        :event-data="event"
        :allow-input="index==achievementIndex"
        @event-reached = "recieveEvent"
        @toggle-grid-highlight = "toggleGridHighlight"
        @toggle-grid-hovering = "toggleGridHovering"
        @update-grid-request = "updateGridLocations"
        @achievement-finished = "recieveAchievement"
      >

      </TetrisPieceContainer>

    </div>
    </div>
    <div class="left">
        <div class="background-line">
            <div class="column">
              <div class="timeline"
              :style="eventOffsetStyle">
                <TimelineItem 
                    v-for = "(event,index) in events"
                    :key = "event.title"
                    :title="event.title"
                    :blockHeight="blockHeight"
                    :numBlocks="event.blocks.length"
                    :index="index"/>
              </div>
            </div>

        </div>
    </div>

    <div class="column middle" ref="middleScroll">
      <div :class="gridHolderClass"
      :style="eventOffsetStyle">
        <Grid 
        :squareSize="blockHeight"
        :eventData="events"
        :key="gridUpdatesRequested"
        @updated-grid-location="receiveGridLocation"
        >
        </Grid>
      </div>

      
        
    </div>
    <!--<div class="footer"></div>-->
  </div>
</template>

<script>
import TimelineItem from './TimelineItem.vue';
import Grid from './Grid.vue';
//import TetrisPiece from './TetrisPiece.vue';
import TetrisPieceContainer from './TetrisPieceContainer.vue';
import eventList from '../content/content.json'




 export default {
    name: 'Layout',

    components:{
        TimelineItem,
        Grid,
        //TetrisPiece,
        TetrisPieceContainer,
    },

    created () {
    },

    mounted(){
      this.calcBlockHeight()
      window.addEventListener('resize',()=>{this.calcBlockHeight()})
    },

    methods: {
      calcBlockHeight(){
        const blockPercent = 0.07
        this.blockHeight = Math.min(document.documentElement.clientHeight*0.1,document.documentElement.clientWidth*blockPercent)
        console.log(this.blockHeight)
      },
      blockHolderBoundingRect(){
        return this.$refs.tetContain.getBoundingClientRect()
      },
      receiveGridLocation(newGridRects){
        //console.log("new grids recieved")
        this.allGridBoundingRects=newGridRects
      },
      recieveEvent(){
        this.eventIndex++;
      },
      recieveAchievement(){
        this.achievementIndex++;
      },
      toggleGridHighlight(){
        this.gridHighlight = !this.gridHighlight
      },
      toggleGridHovering(){
        this.gridHovering = !this.gridHovering
      },
      updateGridLocations(){
        this.gridUpdatesRequested++;
      },
      tetOffsetStyle(index){
        if(index+1>=this.eventIndex){
          return{}
        }
        let offset = 0
        for (let i=index+1;i<this.eventIndex;i++){
          offset+=this.events[i].blocks.length*this.blockHeight;
        }
        return {transform:`translateY(${offset}px)`};
      }
    },
    data() {
      return{
        blockHeight:80,
        gridHighlight:false,
        gridHovering: false,
        gridUpdatesRequested:0,//used as key for grid incrementing causes update
        events:eventList,
        allGridBoundingRects:[],
        eventIndex : 0,
        achievementIndex:0
      }
    },
    computed:{
      eventOffsetStyle(){
        let offset = 0
        for (let i=0;i<this.eventIndex;i++){
          offset+=this.events[i].blocks.length*this.blockHeight;
        }
        return {transform:`translateY(${offset}px)`};
      },
      gridHolderClass(){
        let returnClass = 'grid-holder'
        if(this.gridHighlight){
          returnClass+=' highlight'
        }
        if(this.gridHovering){
          returnClass+=' hovering'
        }
        return returnClass
      },
      
    }
  }

</script>

<style scoped>

.tetris-container {
  
  position: absolute;
  right:0%;
  width: 35%;
  height:100vh;
  overflow-x: visible;
  overflow-y:clip;
  transition: transform 2.5s ease;



}


.container {
  display: flex;
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/art/background.png');
  background-size:cover;
  overflow: hidden;
}

.column {
  height: 100%;
  
  overflow-x: visible;


  padding-bottom:50px;
  
  box-sizing: border-box;
  display:flex;
  flex-direction: column-reverse;

}

.timeline{
  display:flex;
  flex-direction: column-reverse;
  transform: translateY(0px);
  transition: transform 2.5s ease;
}

.left {
  width: 25%;
  order:1;
  padding-left:10px;
  padding-right:10px;
  overflow-x:visible;
  box-sizing:border-box;
  
}

.background-line{
    background: linear-gradient(gray, gray) no-repeat center/4px 100%;
    width:100%;
    height:100%;
}

.middle {
  width: 39.5%;
  background-image: url('../assets/art/gamestage.png');
  background-size:cover;

  order:2;
  overflow: hidden;

}

.right {
  width: 20%;
  flex-direction:column;
  align-self:flex-end;
  right:0;
  bottom:0px;
  overflow-y: hidden;
  overflow-x:visible;
  order:3;
  z-index:100;
  height: 140px;
  padding-left: 10px;
}

.item {
  padding: 10px;
  margin-bottom: 5px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.helper-container{
  display: flex;
  flex-flow:row nowrap;
  align-items: center;
  width:100%;
  height:140px;
  margin-bottom:-80px;
  z-index:200;
}
.helper-text-box{
  width:80%;
  margin-left:-5%;
  margin-bottom:20px;
  background-image: url(../assets/art/dialogue_popup.png);
  background-size: 100% 100%;
  height:100%;
  align-content: center;
  text-align: center;
  z-index:200;

}

.helper-text-speaker{
  width:120px;
  height:120px;
  background-color: white;
  border-radius:50%;
}

.footer{
  position:fixed;
  height:90px;
  bottom:-10px;
  width:100vw;
  background-image: url('../assets/art/footer.png');
  background-size: cover;
  z-index: 100;
}

.grid-holder{
  margin:0px auto;
  transform:translateY(0px);
  transition: transform 2.5s ease;

}

.highlight {
  border: dashed 2px lightgray;
}

.highlight.hovering {
  border-color: gray;
  background-color: rgba(0,0,0,0.2);
}




</style>
